/**
 * @desc 保存spu
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.Response;
export function request(
  body: defs.basics.ProductMasterRequestDtoRPC,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/productMaster/save`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
